import { IReduxAction } from '@bees-web/core/types'
import cookie from 'js-cookie'
import { AnyAction, Dispatch } from 'redux'

import { page, track } from './actions'
import { TRACK_PAGE } from './constants'

export const trackAction = (action: IReduxAction) => {
  return (_dispatch: Dispatch<AnyAction>, getState): void => {
    const anonymousId = cookie?.get('ajs_anonymous_id')?.replace(/"/g, '')
    const userId = cookie?.get('ajs_user_id')
      ? cookie.get('ajs_user_id').replace(/"/g, '')
      : null
    const language = getState().globals?.user?.language
    const country = getState().globals?.user?.country

    const actionSegmentMap = { [TRACK_PAGE]: page }

    const { type } = action
    // eslint-disable-next-line security/detect-object-injection
    const segmentTracking = actionSegmentMap[type] ?? track
    const trackId = crypto.randomUUID()
    const hasLocaleState = language && country
    const locale = hasLocaleState ? `${language}-${country}` : null
    segmentTracking(action, trackId, userId, anonymousId, locale)
  }
}
